import axios from "../../../../helper/axios";
import * as actionTypes from "../../actionTypes";

export const setAdminId = (adminId) => {
  return {
    type: actionTypes.SET_ADMIN_ID,
    adminId,
  };
};

export const fetchAdminsStart = () => {
  return {
    type: actionTypes.FETCH_ADMINS_START,
  };
};
export const fetchAdminsFail = (error) => {
  return {
    type: actionTypes.FETCH_ADMINS_FAIL,
    error,
  };
};
export const fetchAdminsSuccess = (admins, count) => {
  return {
    type: actionTypes.FETCH_ADMINS_SUCCESS,
    admins,
    count,
  };
};

export const fetchAdmins = (pageN, pageS) => {
  return (dispatch) => {
    dispatch(fetchAdminsStart());
    axios
      .get(`admin?pageNumber=${pageN}&pageSize=${pageS}`)
      .then((res) => {
        // console.log(res.data);
        dispatch(fetchAdminsSuccess(res.data.admins, res.data.total));
      })
      .catch((err) => {
        console.log(err);
        console.log(err.response);
        if (err.response) {
          dispatch(fetchAdminsFail(err.response.data.message));
        } else {
          dispatch(fetchAdminsFail("Something went wrong"));
        }
      });
  };
};

export const deleteAdminSuccess = (adminId) => {
  return {
    type: actionTypes.DELETE_ADMIN_SUCCESS,
    adminId,
  };
};
